import AnnualPeriodsError from './AnnualPeriodsError';
class AnnualPeriodsYearsLessThanOne extends AnnualPeriodsError {
    numberOfYears;
    constructor(numberOfYears, options) {
        super('The number of years can not be less than one', options);
        this.numberOfYears = numberOfYears;
    }
}
export default AnnualPeriodsYearsLessThanOne;
